import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Phone, Mail, MapPin } from "lucide-react";
import { ASSETS, BRAND } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-forest-deep pt-20" id="contact" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid gap-12 pb-16 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <img src={ASSETS.logo} alt="Dignity Food Kitchen logo" className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/40" />
              <div>
                <div className="font-display text-2xl text-cream">DIGNITY</div>
                <div className="font-oswald text-[9px] uppercase tracking-[0.3em] text-gold">Food Kitchen</div>
              </div>
            </div>
            <p className="mt-5 font-oswald text-sm uppercase tracking-[0.2em] text-gold">{BRAND.tagline}</p>
            <p className="mt-2 text-sm text-white/40">{BRAND.secondary}</p>
            <div className="mt-6 flex gap-3">
              {[{ Icon: Instagram, href: BRAND.social.instagram, label: "Instagram" },
                { Icon: Facebook, href: BRAND.social.facebook, label: "Facebook" },
                { Icon: Youtube, href: BRAND.social.youtube, label: "YouTube" }].map(({ Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}
                  className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-gold hover:text-gold">
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>

          <FooterCol title="Quick Links" links={[
            { label: "Shop", to: "/shop" }, { label: "About Us", to: "/#about" },
            { label: "Contact", to: "/#contact" }, { label: "Privacy Policy", to: "/privacy" },
            { label: "Terms & Conditions", to: "/terms" }, { label: "Shipping Policy", to: "/shop" },
            { label: "Refund Policy", to: "/shop" }]} />

          <div>
            <h4 className="font-oswald text-sm uppercase tracking-[0.2em] text-gold">Get In Touch</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-3"><Phone size={15} className="text-gold" /> {BRAND.phone}</li>
              <li className="flex items-center gap-3"><Mail size={15} className="text-gold" /> {BRAND.emails.support}</li>
              <li className="flex items-center gap-3"><Mail size={15} className="text-gold" /> {BRAND.emails.sales}</li>
              <li className="flex items-start gap-3"><MapPin size={15} className="mt-0.5 text-gold" /> {BRAND.address}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-oswald text-sm uppercase tracking-[0.2em] text-gold">Departments</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/60">
              <li>CEO — {BRAND.emails.ceo}</li>
              <li>Sales — {BRAND.emails.sales}</li>
              <li>Marketing — {BRAND.emails.marketing}</li>
              <li>Support — {BRAND.emails.support}</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-6 text-xs text-white/40 sm:flex-row">
          <span>© {new Date().getFullYear()} Dignity Food Kitchen. All rights reserved.</span>
          <span className="font-oswald uppercase tracking-[0.2em]">Good Food • Healthy Living</span>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="font-oswald text-sm uppercase tracking-[0.2em] text-gold">{title}</h4>
    <ul className="mt-5 space-y-3 text-sm">
      {links.map((l) => (
        <li key={l.label}>
          <Link to={l.to} className="text-white/60 transition-colors hover:text-gold">{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);
